import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getMasteryIframeUrl } from "../../../api";
import styles from "./DrawerIframe.module.scss";

const MasteryIframe = (props) => {
  const auth = useSelector((state) => state.auth);
  const fiduciary = useSelector((state) => state.folder.fiduciary);
  const [srcUrl, setSrcUrl] = useState("");
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    if (!srcUrl) {
      setIsFetching(true);
      getMasteryIframeUrl(auth.token, fiduciary.id)
        .then((resp) => {
          setSrcUrl(resp.data.data.masteryUrl);
        })
        .catch(() => {})
        .finally(() => setIsFetching(false));
    }
  }, [auth.token]);

  if (srcUrl) {
    return (
      <div style={{ paddingLeft: "70px" }}>
        <iframe
          id="drawer_iframe"
          allow="camera;microphone;autoplay;fullscreen"
          className={styles.iframe}
          allowFullScreen
          src={srcUrl}
          title="TAMTAM portal"
          onLoad={() => {
            if (document.getElementById("iframe-loader")) {
              document.getElementById("iframe-loader").style.display = "none";
            }
          }}
        />
      </div>
    );
  } else {
    return (
      <div style={{ minHeight: "70vh" }}>
        {isFetching && <div className="lmask"></div>}
      </div>
    );
  }
};

export default MasteryIframe;
